import { getKeys } from "@base/util/TypeUtil";
import { Util } from "@base/util/Util";
import { IArticleWithCount } from "@biz/definitions/ArticleDefinitions";
import { IShoppingList, IShoppingListItem, IShoppingListItems } from "@biz/models/ShoppingListDefinitions";

export class ShoppingList {
  static createEmpty(): IShoppingList {
    return { items: {} };
  }

  static calcAllItems(shopList: IShoppingList): IShoppingListItem[] {
    const all: IShoppingListItem[] = [];
    for (const k of getKeys(ShoppingList)) {
      const entry = shopList.items[k];
      if (Array.isArray(entry))
        all.push(...entry);
      all.push(entry);
    }
    return all;
  }


  static findShoppingListItem(items: Record<string, IShoppingListItem>, articleNumber: string, poleIndexFilter?: number): IShoppingListItem | undefined {
    const poleIndexA = poleIndexFilter === undefined ? -1 : poleIndexFilter;

    const keys = Object.keys(items);
    for (const k of keys) {
      const item = items[k];
      if (item.articleNumber === articleNumber) {
        if (poleIndexFilter !== undefined) {
          const poleIndexB = item?.affiliation?.poleId === undefined ? -1 : item.affiliation.poleId;
          if (poleIndexA !== poleIndexB)
            continue;
        }
        return item;
      }
    }
    return undefined;
  }

  static findShoppingListItems(items: Record<string, IShoppingListItem>, articleNumber: string[], poleIndexFilter?: number): IShoppingListItem[] {
    const foundItems: IShoppingListItem[] = [];
    const poleIndexA = poleIndexFilter === undefined ? -1 : poleIndexFilter;

    const keys = Object.keys(items);
    for (const k of keys) {
      const item = items[k];
      if (articleNumber.includes(item.articleNumber)) {
        if (poleIndexFilter !== undefined) {
          const poleIndexB = item?.affiliation?.poleId === undefined ? -1 : item.affiliation.poleId;
          if (poleIndexA !== poleIndexB)
            continue;
        }
        foundItems.push(item);
      }
    }
    return foundItems;
  }

  static hasArticle(items: Record<string, IShoppingListItem>, articleNumber: string, defaultValue: number, poleIndexFilter: number | undefined): boolean {
    const item = ShoppingList.findShoppingListItem(items, articleNumber, poleIndexFilter);
    if (item === undefined)
      return defaultValue > 0;
    return item.count !== undefined && item.count > 0;
  }

  static getArticleCount(items: Record<string, IShoppingListItem>, articleNumber: string, defaultValue: number, poleIndexFilter: number | undefined): number {
    const item = ShoppingList.findShoppingListItem(items, articleNumber, poleIndexFilter);
    if (item === undefined)
      return defaultValue;
    return item.count || 0;
  }
}


export class WishList {
  static findShoppingListItem(items: IShoppingListItems, articleNumbers: string | string[], options?: { poleIndexFilter?: number }): IShoppingListItem[] {
    const poleIndexA = options?.poleIndexFilter === undefined ? -1 : options?.poleIndexFilter;
    articleNumbers = Util.ensureArray(articleNumbers);

    const ret: IShoppingListItem[] = [];

    const keys = Object.keys(items);
    for (const k of keys) {
      const item = items[k];
      if (articleNumbers.includes(item.articleNumber)) {
        if (options?.poleIndexFilter !== undefined) {
          const poleIndexB = item?.affiliation?.poleId === undefined ? -1 : item.affiliation.poleId;
          if (poleIndexA !== poleIndexB)
            continue;
        }
        ret.push(item);
      }
    }
    return ret;
  }

  static getArticleCount(items: IShoppingListItems, articleNumber: string | string[], options?: { poleIndexFilter?: number, defaultValue?: number }): number {
    const itemArray = WishList.findShoppingListItem(items, articleNumber, options);
    if (!itemArray.length)
      return options?.defaultValue || 0;
    let totalCount = 0;
    for (const item of itemArray)
      totalCount += item.count || 0;
    return totalCount;
  }

  static hasArticle(items: IShoppingListItems, articleNumber: string | string[], options?: { poleIndexFilter?: number }): boolean {
    const count = WishList.getArticleCount(items, articleNumber, options);
    return !!count;
  }

  static getArticleCounts(items: IShoppingListItems, articles: IArticleWithCount[], options?: { poleIndexFilter?: number }): { count: number, articles: IArticleWithCount[] } {
    let totalCount = 0;
    const ret: IArticleWithCount[] = [];
    for (const a of articles) {
      const count = WishList.getArticleCount(items, a.articleNumber, { ...options, defaultValue: a.count });
      ret.push({ articleNumber: a.articleNumber, count })
      totalCount += count;
    }
    return {
      count: totalCount,
      articles: ret
    };
  }
}